const HousePlant = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='54'
    height='96'
    viewBox='0 0 54 96'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <mask
      id='mask0_3389_3166'
      style={{
        maskType: 'luminance',
      }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='35'
      width='54'
      height='45'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.28125 35.7139H53.3114V79.714H0.28125V35.7139Z'
        fill='white'
      />
    </mask>
    <g mask='url(#mask0_3389_3166)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M40.8309 46.2434C36.9736 46.2434 33.4772 47.765 30.8916 50.2329V35.7139H22.7011V50.2329C20.1155 47.765 16.6191 46.2434 12.7617 46.2434C7.42781 46.2434 2.77406 49.1436 0.28125 53.4504C2.77406 57.7573 7.42781 60.6575 12.7617 60.6575C16.6191 60.6575 20.1155 59.1354 22.7011 56.6679V79.714H30.8916V56.6679C33.4772 59.1354 36.9736 60.6575 40.8309 60.6575C46.1653 60.6575 50.8191 57.7573 53.3114 53.4504C50.8191 49.1436 46.1653 46.2434 40.8309 46.2434Z'
        fill='#006837'
      />
    </g>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.0762 41.3846H43.5177V21.7871H10.0762V41.3846Z'
      fill='#FFA926'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M30.8916 30.9636C30.8916 28.7277 29.0593 26.915 26.7985 26.915C24.6305 26.915 22.861 28.5829 22.7185 30.6908H22.7012V41.3854H30.8771V41.2644H30.8916V30.9636Z'
      fill='#FFEDD7'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.7205 35.0441C29.7205 35.6113 29.2607 36.0716 28.693 36.0716C28.1254 36.0716 27.665 35.6113 27.665 35.0441C27.665 34.4764 28.1254 34.0166 28.693 34.0166C29.2607 34.0166 29.7205 34.4764 29.7205 35.0441Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5508 36.8557H19.5583V26.8994H13.5508V36.8557Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M34.0342 36.8557H40.0412V26.8994H34.0342V36.8557Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M39.9655 14.1753H37.3485V9.71094H34.4675V14.1753H32.0127V9.71094H29.1318V14.1753H13.6264C11.6652 14.1753 10.0752 15.7653 10.0752 17.7266V22.4347H43.5168V17.7266C43.5168 15.7653 41.9272 14.1753 39.9655 14.1753Z'
      fill='#FF620F'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.8775 4.58109C27.4659 4.58109 27.0713 4.65375 26.7028 4.78125C26.0691 2.4075 23.91 0.65625 21.3366 0.65625C19.0186 0.65625 17.0334 2.07609 16.1986 4.09219C15.5798 3.78 14.8823 3.6 14.1412 3.6C11.6128 3.6 9.5625 5.64984 9.5625 8.17875H15.7767H18.72H24.2803H25.5881H31.4756C31.4756 6.19172 29.8645 4.58109 27.8775 4.58109Z'
      fill='#91C5F0'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.5032 95.1753L9.91699 66.3477H43.6759L36.0892 95.1753H17.5032Z'
      fill='#CF8640'
    />
  </svg>
);

export default HousePlant;
